import { jsx as _jsx } from "react/jsx-runtime";
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { useCallback, useRef } from 'react';
import Spinner from '@/components/atoms/Spinner/Spinner';
const CategoryLoadMore = ({ onLoadMore, status }) => {
    const ref = useRef(null);
    const callback = useCallback((entry, disconnect) => {
        if (entry.isIntersecting && status === 'Pending') {
            onLoadMore();
            disconnect();
        }
    }, [status, onLoadMore]);
    useIntersectionObserver(ref, {
        threshold: 0,
        rootMargin: '500px',
    }, callback);
    if (status === 'Completed') {
        return null;
    }
    return (_jsx("div", { ref: ref, className: "flex items-center justify-center py-4", "data-testid": "category-load-more", "aria-hidden": true, children: _jsx(Spinner, {}) }));
};
export default CategoryLoadMore;
